var map = {
	"./symbol_0.png": 46666,
	"./symbol_1.png": 62227,
	"./symbol_10.png": 1083,
	"./symbol_2.png": 66616,
	"./symbol_3.png": 87745,
	"./symbol_4.png": 89262,
	"./symbol_5.png": 88759,
	"./symbol_6.png": 64828,
	"./symbol_7.png": 17093,
	"./symbol_8.png": 95714,
	"./symbol_9.png": 86219
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68077;